import { createReducer } from 'typesafe-actions'
import { IAssets } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import { getAllInstrumentsFailure, getAllInstrumentsRequest, getAllInstrumentsSuccess } from '../actions'
import { LoadingStateEnum } from '../../types'

export type InstrumentsState = {
  allInstruments: {
    status: LoadingStateEnum
    data: IAssets[]
    error: Error | null
  }
}

export const initialState: InstrumentsState = {
  allInstruments: {
    status: LoadingStateEnum.IDLE,
    data: [],
    error: null,
  },
}

export const instruments = createReducer<InstrumentsState, ActionTypes>(initialState)
  .handleAction(getAllInstrumentsRequest, (state) => ({
    ...state,
    allInstruments: {
      ...state.allInstruments,
      status: LoadingStateEnum.LOADING,
    },
  }))
  .handleAction(getAllInstrumentsSuccess, (state, { payload }) => ({
    ...state,
    allInstruments: {
      ...state.allInstruments,
      status: LoadingStateEnum.SUCCESS,
      data: payload,
    },
  }))
  .handleAction(getAllInstrumentsFailure, (state, { payload }) => ({
    ...state,
    allInstruments: {
      ...state.allInstruments,
      status: LoadingStateEnum.ERROR,
      error: payload,
    },
  }))
